export default "__VITE_ASSET__Bk17sXue__"